import { Icon } from "@/components/icon/Icon";
import { FAQ } from "./content";

/** Native details/summary accordion: keyboard and screen-reader friendly without a library. */
export function Faq() {
  return (
    <section aria-labelledby="faq-title" className="bg-background-alternative">
      <div className="mx-auto grid max-w-layout gap-10 px-5 py-20 md:grid-cols-[minmax(0,4fr)_minmax(0,8fr)]">
        <h2 id="faq-title" className="wds-title-2 text-label-strong break-keep">
          자주 묻는 질문
        </h2>
        <div className="flex flex-col">
          {FAQ.map((f, i) => (
            <details
              key={f.q}
              className={i > 0 ? "shadow-[inset_0_1px_0_var(--line-normal-neutral)]" : ""}
            >
              <summary className="flex min-h-14 items-center justify-between gap-4 py-4 wds-headline-1 text-label-strong">
                <span className="break-keep">{f.q}</span>
                <Icon
                  name="chevronDown"
                  size={20}
                  className="tv-caret flex-none text-label-neutral"
                />
              </summary>
              <p className="pb-6 text-body-1 font-regular text-label-neutral break-keep">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
